/**
 * Currency + exact-decimal money helpers (web).
 * Mirrors the backend behaviour: values are NEVER rounded to integers; decimals
 * are preserved. IQD is the safe, backward-compatible default currency.
 */

export const CURRENCY_OPTIONS = [
  { code: "IQD", symbol: "ع.د" },
  { code: "USD", symbol: "$" },
];

export const currencySymbol = (currency) =>
  (CURRENCY_OPTIONS.find((c) => c.code === String(currency || "IQD").toUpperCase()) ||
    CURRENCY_OPTIONS[0]).symbol;

export const normalizeCurrency = (currency) => {
  const c = String(currency || "IQD").toUpperCase();
  return c === "USD" || c === "IQD" ? c : "IQD";
};

/**
 * Remove floating-point noise (e.g. 0.1 * 0.2 -> 0.020000000000000004) WITHOUT
 * altering the intended decimal value. 12 significant digits is well within a
 * double's safe range and covers realistic construction prices.
 */
export const cleanNum = (n) => {
  const num = typeof n === "number" ? n : parseFloat(n);
  if (!Number.isFinite(num)) return 0;
  if (num === 0) return 0;
  return parseFloat(num.toPrecision(12));
};

/**
 * Format a monetary value: thousands separators, decimals preserved (no forced
 * fixed places, no integer rounding), with the estimation currency symbol.
 * USD -> "$1,987.9"  |  IQD -> "1,987.9 ع.د"
 */
export const fmtMoney = (value, currency = "IQD") => {
  const n = cleanNum(value);
  const formatted = new Intl.NumberFormat("en-US", { maximumFractionDigits: 12 }).format(n);
  const code = normalizeCurrency(currency);
  return code === "USD" ? `$${formatted}` : `${formatted} ع.د`;
};
